module.exports = __webpack_public_path__ + "img/2AA.1.b515c811.jpg";